import { ApiViewerToolbar } from '~/portal/components/ApiViewerToolbar'
import { SyntaxRenderer } from '~/portal/components/SyntaxRenderer'
import { API_FILE_TYPES } from '~/portal/types/downloadApi'
import { CONTENT_TYPE } from '~/shared/types/content'

const grpcDownloadOptions = [{ id: '1', name: API_FILE_TYPES.GRPC }]

export const GrpcViewer = ({
  tableOfContentsId,
  title,
  registryUrl,
  content,
  lastModifiedDate,
  providerContentSlug,
  shubUrl,
  showEditButtons,
  accentColor,
  fontName,
  isConsumerSide = true,
  downloadDisabled,
}: {
  tableOfContentsId?: string
  title?: string
  registryUrl?: string
  content?: object
  lastModifiedDate?: string
  providerContentSlug?: string
  shubUrl?: string
  showEditButtons?: boolean
  accentColor?: string
  fontName?: string
  isConsumerSide?: boolean
  downloadDisabled?: boolean
}) => {
  const buildDownloadUrl = registryUrl
    ? () => `/services/api/grpc-download?url=${encodeURIComponent(registryUrl)}&filename=${encodeURIComponent(title ?? 'api')}`
    : undefined

  return (
    <div
      data-testid="grpc-markdown-container"
      id="top"
      className="flex flex-col"
      style={{ fontFamily: fontName }}
    >
      <ApiViewerToolbar
        testId="grpc-viewer-toolbar"
        downloadOptions={grpcDownloadOptions}
        buildDownloadUrl={buildDownloadUrl}
        optionLabelBuilder={() => API_FILE_TYPES.GRPC}
        providerContentSlug={providerContentSlug}
        shubUrl={shubUrl}
        showEditButtons={showEditButtons}
        accentColor={accentColor}
        downloadDisabled={downloadDisabled}
      />
      <div className="relative">
        <SyntaxRenderer
          key={tableOfContentsId}
          type={CONTENT_TYPE.GRPC}
          content={content}
          title={title}
          lastModifiedDate={lastModifiedDate}
          providerContentSlug={providerContentSlug}
          isConsumerSide={isConsumerSide}
          useMarkdocRenderer={true}
        />
      </div>
    </div>
  )
}
